import Header from '../Header'
import CartListView from '../CartListView'

import EmptyCartView from '../EmptyCartView'

import CartContext from '../../context/CartContext'

import './index.css'

const Cart = () => (
  <CartContext.Consumer>
    {value => {
      const {cartList, emptyCartList} = value
      const showEmptyView = cartList.length === 0
      const onClickRemoveAllBtn = () => {
        emptyCartList()
      }
      return (
        <>
          <Header />
          {showEmptyView ? (
            <EmptyCartView />
          ) : (
            <div className="cart-container">
              <div className="cart-content-container">
                <div className="my-cart-heading-and-remove-all-btn-cont">
                  <h1 className="cart-heading">My Cart</h1>
                  <button
                    className="remove-all-btn"
                    type="button"
                    onClick={onClickRemoveAllBtn}
                  >
                    Remove all
                  </button>
                </div>
                <CartListView />
              </div>
            </div>
          )}
        </>
      )
    }}
  </CartContext.Consumer>
)
export default Cart
